const apiRequest = "https://ipapi.co/country/";

fetch("https://ipapi.co/country/").then(function(response) {
	return response.text().then(function(text) {
      if(text != "IT") {
      	for (let element of document.getElementsByClassName("product__price")){
   			element.style.display="none";
		}
        for (let element of document.getElementsByClassName("price--listing")){
   			element.style.display="none";
		}
        for (let element of document.getElementsByClassName("product-form__item--payment-button")){
   			element.style.display="none";
		}
        for (let element of document.getElementsByClassName("product__policies")){
   			element.style.display="none";
		}
      }
    });
});
